import * as rs from 'jsrsasign';
import { DigitalSignature } from '../types/eCMR';

/**
 * Genera una firma digital simple para un documento
 * @param documentData Datos del documento a firmar
 * @returns String con la firma digital (hash)
 */
export const generateSignature = (documentData: string): string => {
  try {
    // Genera un hash del contenido para simular una firma
    const md = new rs.KJUR.crypto.MessageDigest({ alg: "sha256" });
    md.updateString(documentData);
    return md.digest();
  } catch (error) {
    console.error("Error al generar firma:", error);
    throw new Error(`No se pudo generar la firma: ${(error as Error).message}`);
  }
};

/**
 * Valida las firmas de un documento eCMR
 * @param consignorSignature Firma del remitente
 * @param carrierSignature Firma del transportista
 * @param consigneeSignature Firma del destinatario (opcional)
 * @returns Objeto con estado de validación y firmas pendientes
 */
export const validateSignatureStatus = (
  consignorSignature?: DigitalSignature,
  carrierSignature?: DigitalSignature,
  consigneeSignature?: DigitalSignature
): {
  complete: boolean;
  validSignatures: number;
  totalRequired: number;
  missingSignatures: string[];
} => {
  const missingSignatures: string[] = [];
  let validSignatures = 0;
  
  // El remitente debe firmar
  if (consignorSignature) {
    validSignatures++;
  } else {
    missingSignatures.push('Remitente');
  }
  
  // El transportista debe firmar
  if (carrierSignature) {
    validSignatures++;
  } else {
    missingSignatures.push('Transportista');
  }
  
  // La firma del destinatario puede ser opcional hasta la entrega
  // pero se considera necesaria para un documento completo
  if (consigneeSignature) {
    validSignatures++;
  } else {
    missingSignatures.push('Destinatario');
  }
  
  // Para ser completo, necesita todas las firmas
  const totalRequired = 3;
  const complete = validSignatures === totalRequired;
  
  return {
    complete,
    validSignatures,
    totalRequired,
    missingSignatures
  };
}; 